import { useEffect, useState } from "react";
import Container from "react-bootstrap/Container";
import Table from "react-bootstrap/Table";
import Form from "react-bootstrap/Form";
import Badge from "react-bootstrap/Badge";
import { listSurveyResponses } from "../../services/ledgerService";

const FILTERS = [
    { value: "", label: "All surveys" },
    { value: "usage", label: "Usage (latent hosts)" },
    { value: "churn", label: "Churn (tire-kickers)" },
];

// avg returns the mean rating of the responses, or null when there are none.
function avg(responses) {
    if (!responses.length) return null;
    const sum = responses.reduce((acc, r) => acc + (r.rating || 0), 0);
    return (sum / responses.length).toFixed(1);
}

const SurveyResults = () => {
    const [survey, setSurvey] = useState("");
    const [responses, setResponses] = useState(null);
    const [error, setError] = useState(null);

    useEffect(() => {
        setResponses(null);
        setError(null);
        listSurveyResponses(survey)
            .then(setResponses)
            .catch((e) => setError(e.message));
    }, [survey]);

    return (
        <Container className="py-4 admin-page">
            <h1 className="mb-4">Survey responses</h1>

            <div className="d-flex align-items-center gap-3 mb-3">
                <Form.Select
                    style={{ width: "auto" }}
                    value={survey}
                    onChange={(e) => setSurvey(e.target.value)}
                    aria-label="Survey filter"
                >
                    {FILTERS.map((f) => (
                        <option key={f.value} value={f.value}>{f.label}</option>
                    ))}
                </Form.Select>
                {responses && (
                    <span className="text-muted">
                        {responses.length} response{responses.length === 1 ? "" : "s"}
                        {avg(responses) !== null && <> · avg rating <strong>{avg(responses)}</strong></>}
                    </span>
                )}
            </div>

            {error ? (
                <div className="text-danger">Error: {error}</div>
            ) : !responses ? (
                <div className="text-muted">Loading…</div>
            ) : responses.length === 0 ? (
                <div className="text-muted">No responses yet.</div>
            ) : (
                <Table striped hover responsive>
                    <thead>
                        <tr>
                            <th>When</th>
                            <th>Survey</th>
                            <th className="text-center">Rating</th>
                            <th>Comment</th>
                            <th>Email</th>
                        </tr>
                    </thead>
                    <tbody>
                        {responses.map((r) => (
                            <tr key={r.id}>
                                <td className="text-nowrap">{r.createdAt}</td>
                                <td><Badge bg={r.survey === "usage" ? "info" : "secondary"}>{r.survey}</Badge></td>
                                <td className="text-center">{r.rating || "—"}</td>
                                <td>{r.comment || <em className="text-muted">—</em>}</td>
                                <td className="small">{r.email || <em>anonymous</em>}</td>
                            </tr>
                        ))}
                    </tbody>
                </Table>
            )}
        </Container>
    );
};

export default SurveyResults;
